import dayjs from 'dayjs';

import { DATE_FORMAT, DATE_PERIOD_FORMAT } from '../constants-module';
import { capitalize } from './capitalize';

export const formatDate = (date: string) => dayjs(date).format(DATE_FORMAT);

export const formatPeriod = (date: string) => capitalize(dayjs(date).format(DATE_PERIOD_FORMAT));
